(function() {
  if (window.swatchHoverInitialized) return;
  window.swatchHoverInitialized = true;
  
  document.addEventListener('mouseover', function(e) {
    const swatch = e.target.closest('[data-swatch-hover]');
    if (!swatch) return;
    const card = swatch.closest('.card-product');
    const img = card?.querySelector('.main-product-image');
    const variantImg = swatch.getAttribute('data-variant-image');
    if (img && variantImg) {
      if (!img.getAttribute('data-original-src')) {
        img.setAttribute('data-original-src', img.src);
        img.setAttribute('data-original-srcset', img.srcset || '');
      }
      img.srcset = '';
      img.src = variantImg;
    }
  }, true);
  
  document.addEventListener('mouseout', function(e) {
    const swatch = e.target.closest('[data-swatch-hover]');
    if (!swatch) return;
    const card = swatch.closest('.card-product');
    const img = card?.querySelector('.main-product-image');
    const originalSrc = img?.getAttribute('data-original-src');
    const originalSrcset = img?.getAttribute('data-original-srcset');
    if (img && originalSrc) {
      img.src = originalSrc;
      if (originalSrcset) img.srcset = originalSrcset;
    }
  }, true);
  
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('[data-swatch-hover]');
    if (!swatch) return;
    const card = swatch.closest('.card-product');
    const img = card?.querySelector('.main-product-image');
    const variantImg = swatch.getAttribute('data-variant-image');
    if (img && variantImg) {
      img.setAttribute('data-original-src', variantImg);
      img.setAttribute('data-original-srcset', '');
    }
  }, true);
})();

